const entityTypes = {
  PAGE: 'PAGE'
};

export default entityTypes;